export default __webpack_public_path__ + "static/img_right_people-c7018609d5d00b5ba773feefc6aa991a.png";